import React from 'react';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';
import EditGoal from './editGoal.component';
import AddKrSection from './addkr.component';
import GoalServices from '../../../services/goal.services';
import {
  autoResizeTextArea,
  reactLoader,
  removeReactLoader
} from '../../../utils/common.js';
import InlineKrEditComp from './krInlineEdit.component';
import { CoauthorButtonGroup, CoauthorButtonWithPortal, getCoauthorConfig } from './coauthor';
import { KeyDownEvent } from '../../../utils/eventKey';
import { ThemeProvider } from '@workboard/wobo-ui';
import he from 'he';
import { flushSync } from 'react-dom';

const TEXTAREA_IDS = {
  newObjective: 'goalNameclasId',
  editObjective: 'goalTextObjective',
}

const EditObjectiveToolbar = styled('div')({
  display: 'inline-flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 8,
  '& > button': {
    marginTop: 10
  },
})

class AddGoal extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    let isSetGoal = this.props.addOkrData.goalDetails ? false : true;
    this.state = {
      okrAlignmentSuggestionsDate: [],
      addGoalFinished: false,
      addGoalValue: this.props.addOkrData.goalDetails
        ? this.props.addOkrData.goalDetails.goal
        : "",
      rightokrpane: false,
      setGoal: isSetGoal,
      addKrValue: "",
      addKrFinished: false,
      setKr: true,
      goalDependenciesEn: false,
      goalErrorText: false,
      wsArchiEn: false,
      divWsArchiEn: true,
      goalType: this.props.goalType,
      goalSubmitted: false,
      alignCount:
        this.props.addOkrData.goalDetails &&
          this.props.addOkrData.goalDetails.goal_aligns
          ? this.props.addOkrData.goalDetails.goal_aligns.length
          : 0,
      ownerList: [],
      goalEditId: false,
      // isFiscal: this.props.addOkrData.goalDetails ? (Object.values(this.props.addOkrData.goalDetails.filterOption).filter(
      //             val => val.stats == 1
      //           )[0].name.includes('Fiscal') ? Object.values(this.props.addOkrData.goalDetails.filterOption).filter(
      //             val => val.stats == 1
      //           )[0].name.slice(-5,-1) : ''): '',
      editGoalValue:
        this.props.addOkrData.goalDetails &&
          this.props.addOkrData.goalDetails.goal
          ? this.props.addOkrData.goalDetails.goal
          : "",
      teamOptions: [],
      timePeriodOptions: [],
      teamId: undefined,
      timePeriod: undefined
      // workStreamKRSelect: []
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleKrChange = this.handleKrChange.bind(this);
    this.setRightPaneState = this.setRightPaneState.bind(this);
    this.saveGoalInfo = this.saveGoalInfo.bind(this);
    this.cancelKrInfo = this.cancelKrInfo.bind(this);
    this.saveKrArr = this.saveKrArr.bind(this);
    this.onEnterPress = this.onEnterPress.bind(this);
    this.dependentGoal = this.dependentGoal.bind(this);
    this.GoalServices = new GoalServices();
    this.editGoalRightPane = this.editGoalRightPane.bind(this);
    this.handleDoubleClickItem = this.handleDoubleClickItem.bind(this);
    this.handleSaveGoalChange = this.handleSaveGoalChange.bind(this);
    this.UpdateGoalName = this.UpdateGoalName.bind(this);
    this.clickEvent = this.clickEvent.bind(this);
  }

  componentDidMount() {
    //console.log(this.state.goalType);
    this._isMounted = true;
    $(window).scrollTop(0);
    if (this.textarea) {
      this.textarea.focus();
    }
    let windowHeight = $(window).height();
    $("#add_goal_page #mainAddGoalDiv").css({
      "min-height": windowHeight - 64
    });

    $('body').css({
      height: windowHeight
    });

    window.addEventListener('coauthorSaveObjective', this.handleCoauthorSaveObjective)
    window.addEventListener('coauthorConfigChange', this.handleCoauthorConfigChange);
    document.addEventListener('mousedown', this.clickEvent, false);
    this.initCoauthorOptions();

    // IE Placeholder
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      // If Internet Explorer, return version number
      // console.log("in side place holder react");
      $(".goalNameClas").placeHolder();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    document.removeEventListener('mousedown', this.clickEvent, false);
    window.removeEventListener('coauthorSaveObjective', this.handleCoauthorSaveObjective)
    window.removeEventListener('coauthorConfigChange', this.handleCoauthorConfigChange);
  }

  handleCoauthorSaveObjective = (e) => {
    const { value, originatorId } = e.detail;
    switch (originatorId) {
      case TEXTAREA_IDS.newObjective:
        window.openOkrCoauthor({ type: 'CLOSE' });
        flushSync(() => {
          this.handleChange({ target: { value } });
        });
        this.onEnterPress();
        break;
      case TEXTAREA_IDS.editObjective:
        window.openOkrCoauthor({ type: 'CLOSE' });
        this.setState({ editGoalValue: value });
        this.UpdateGoalName(this.props.addOkrData.goalDetails.id);
        break;
      default: break;
    }
  }

  handleCoauthorConfigChange = (e) => {
    const config = e.detail;
    this.setState({
      teamId: this.state.goalType == 1 ? config.team?.id : undefined,
      timePeriod: config.timePeriod
    });
  }

  handleChange(event) {
    let goalNameText = event.target.value != "" ? event.target.value : "";
    autoResizeTextArea(this.textarea);
    this.setState({
      addGoalValue: event.target.value,
      addGoalFinished: event.target.value != "" ? true : false,
      goalErrorText: event.target.value.length < 1 ? true : false
    });
    this.props.goalTextWithOutsave(goalNameText);
  }

  handleKrChange(event) {
    this.setState({
      addKrValue: event.target.value,
      addKrFinished: event.target.value != "" ? true : false
    });
  }

  setRightPaneState() {
    this.props.enableEscFunc();
    if (
      this.props.addOkrData.goalDetails &&
      this.props.addOkrData.goalDetails.id
    ) {
      this.setState({
        rightokrpane: false,
        addGoalFinished: false,
        setGoal: false,
        goalSubmitted: true,
        divWsArchiEn: true
      });
    } else {
      this.setState({
        rightokrpane: false,
        addGoalFinished: true,
        setGoal: true,
        goalSubmitted: false,
        divWsArchiEn: true
      });
      this.props.handleGoalDoneChange();
      this.textarea.focus();
    }
    $(window).scrollTop(0);
    return overflowHiddenFunction(false);
  }

  // saveGoalInfo(updatedAlignCount = 0, isFiscal = this.state.isFiscal) {
  saveGoalInfo(updatedAlignCount = 0) {
    this.setState({
      rightokrpane: false,
      addGoalFinished: false,
      setGoal: false,
      goalSubmitted: true,
      alignCount: updatedAlignCount,
      divWsArchiEn: true,
      // isFiscal
    });
    //setGoal: false,
    this.props.enableEscFunc();
    this.props.handleGoalDoneChange();
    return overflowHiddenFunction(false);
  }

  cancelKrInfo() {
    // this.setState({ setGoal: false, })
  }

  saveKrArr() {
    let krName = "";
    this.setState({ goalDependenciesEn: true });
    this.props.krTextWithOutsave(krName);
  }

  onEnterPress(e) {
    autoResizeTextArea(this.textarea);
    if (!e || e.keyCode == 13) {
      e?.preventDefault();
      let goalName = this.state.addGoalValue.trim();
      goalName = he.encode(goalName);
      let { actions, addOkrData } = this.props;
      const teamId = this.state.teamId ?? addOkrData.teamId ?? "";
      let _this = this;
      let parentGoalAlign = (this.props.addOkrData && this.props.addOkrData.parent_goal_align) ? this.props.addOkrData.parent_goal_align : null;
      this.setState({
        goalErrorText: false
      }, () => {
        this.setState({
          goalErrorText: goalName === "" ? true : false
        })
      });

      if (!this.state.goalErrorText && goalName.length > 0) {
        // save goal and update JSON
        reactLoader(true);
        let goalType = this.state.goalType;
        this.GoalServices.addEditObjective({
          goal: { goal: goalName, type: goalType, saveData: 0, team_id: teamId, parentGoalAlignId : parentGoalAlign }
        }).then(response => {
          removeReactLoader();
          if (response.data) {
            response.data.data.goal = he.decode(response.data.data.goal);
            actions.addNewOkr(response.data);

            const channel = new BroadcastChannel('okr:objectiveCreated');
            channel.postMessage(response.data.data.team_id);

            if (_this.props.addOkrData.goalDetails.type === "1") {
              _this.GoalServices.getOwnerNamebyTeamID({
                teamId: _this.props.addOkrData.goalDetails.team_id
              }).then(function (response) {
                if (response.data) {
                  _this.setState({
                    rightokrpane: true,
                    addGoalFinished: false,
                    ownerList: [...response.data]
                  });
                }
              });
            } else {
              this.setState({ rightokrpane: true, addGoalFinished: false });
            }
            console.log('response.data', response.data)
            const { start_date, target_date, type, team_id } = response.data.data;
            if (type == 1) {
              this.GoalServices.nlpOkrAlignment({q: goalName, team_id, start_date, end_date: target_date})
              .then((responseData) => {
                if(responseData.data.data.length > 0){
                  let okrIds = responseData.data.data.map((x)=>x.id)
                  this.GoalServices.nlpEventTrack({ref:"NLP_OKR_ALIGNMENT_FOUND",okrId:okrIds})
                }
               this.setState({okrAlignmentSuggestionsDate : responseData.data.data})
              });
            }
          }
        });
      }
    }
  }

  dependentGoal() {
    this.setState({
      rightokrpane: !this.state.rightokrpane,
      divWsArchiEn: false
    });
    $(window).scrollTop(0);
    overflowHiddenFunction(true);
    let windowHeight = $(window).height();
    $("#add_goal_page #mainAddGoalDiv").css({
      "min-height": windowHeight - 64
    });
  }

  editGoalRightPane() {
    let _this = this;
    if (this.props.onOpenEditObjective) {
      this.props.onOpenEditObjective();
    }
    if (
      _this.props.addOkrData.goalDetails.type === "1" &&
      _this.props.addOkrData.goalDetails.team_id &&
      _this.props.addOkrData.goalDetails.team_id.length > 0
    ) {
      _this.GoalServices.getOwnerNamebyTeamID({
        teamId: _this.props.addOkrData.goalDetails.team_id
      }).then(function (response) {
        if (response.data) {
          // console.log('GETTING RESPONSE ON EDIT', response.data);
          _this.setState({
            rightokrpane: !_this.state.rightokrpane,
            ownerList: [...response.data]
          });
        }
      });
    } else {
      _this.setState({ rightokrpane: !_this.state.rightokrpane });
    }
    return overflowHiddenFunction(true);
  }

  handleDoubleClickItem(id) {
    //console.log(id);
    this.setState({
      goalEditId: id,
      goalErrorText: id == null || id == "" ? true : false
    });
  }
  handleSaveGoalChange(val) {
    this.setState({
      editGoalValue: val,
      goalErrorText: val.length > 0 ? false : true
    });
  }

  SendFcousToGoalTextObj=()=>{
    setTimeout(() => {
      document.getElementById(TEXTAREA_IDS.editObjective).focus();
    });
  }

  UpdateGoalName(goalId) {
    let goalNewName = this.state.editGoalValue;
    let _this = this;
    document.getElementById("goalTextObjectiveEmpty").focus();
    if (
      goalId != "" &&
      goalId != null &&
      goalId != undefined &&
      goalNewName != "" &&
      goalNewName != this.props.addOkrData.goalDetails.goal
    ) {
      let { actions } = this.props;
      let params = {};
      params.goal = he.encode(goalNewName);
      params.id = goalId;
      this.GoalServices.updateGoalName({ goal: params }).then(response => {
        if (response.data) {
          if (typeof goalId !== "undefined" && goalId != null) {
            // console.log('setting obj to edit -- ADD GOAL PAGE');
            _this.props.addOkrObject.setState({ goalOperation: "edit" });
          } else {
            // console.log('setting obj to new -- ADD GOAL PAGE');
            _this.props.addOkrObject.setState({ goalOperation: "new" });
          }
          actions.updateGoalName(goalId, goalNewName);
          _this.setState({
            goalEditId: ""
          });
          this.SendFcousToGoalTextObj();
          updateRecentItemsTopMenu(goalId, "recent_goal", goalNewName);
          updateTopMenuObjectName(goalId, "goal", goalNewName);
          updateLeftMenuData("goal", goalId, "goal", "update", {
            name: goalNewName
          });
          $(window).scrollTop(0);
          // this.GoalServices.triggerGoalMetricDetails({ goalId });
        }
      });

      actions.updateGoalName(goalId, goalNewName);
      this.setState({
        goalEditId: ""
      });
      this.SendFcousToGoalTextObj();
      $(window).scrollTop(0);
    } else if (
      goalId != "" &&
      goalId != null &&
      goalId != undefined &&
      goalNewName == ""
    ) {
      this.setState({
        goalErrorText: true
      });
    } else {
      this.setState({
        goalEditId: ""
      });
      this.SendFcousToGoalTextObj();
    }
  }
  clickEvent(e) {
    let goalId =
      this.props.addOkrData &&
        this.props.addOkrData.goalDetails &&
        this.props.addOkrData.goalDetails.id
        ? this.props.addOkrData.goalDetails.id
        : "";
    if (
      !$(".clickOutInlineGoal").is(e.target) &&
      $(".clickOutInlineGoal").has(e.target).length === 0
    ) {
      if (this._isMounted) {
        if (this.state.goalEditId.length > 0) {
          this.UpdateGoalName(goalId);
        }
        this.setState({
          goalEditId: ""
        });
      }
    }
  }
  initCoauthorOptions = async () => {
    const { goalType } = this.state
    const [newOkrData, teamOptions] = await Promise.all([
      this.GoalServices.addEditObjective({
        goal: {
          type: goalType,
          saveData: 0,
        },
      }).then(response => response.data?.data ?? {}),
      this.GoalServices.searchTeamName({
        term: '',
        offset: 0,
        limit: 100
      }).then(response => response.data ?? [])]);

    const timePeriodOptions = this.props.addOkrData?.goalDetails?.filterOption ?? newOkrData.filterOption ?? [];
    // timePeriod defaults in order: saved timePeriod (edit OKR), first option in filterOptions (new OKR)
    const timePeriod = Object.values(timePeriodOptions).find(val => val.stats == 1) ?? timePeriodOptions[0];
    // teamId defaults in order: saved teamId (edit OKR), passed teamId (new team OKR from team page), default teamId (new OKR), first option teamId (should never happen)
    const teamId = this.props.addOkrData?.goalDetails?.team_id || this.props.addOkrData?.teamId || newOkrData.team_id || teamOptions[0]?.id;
    // this is required to keep the default team and timeperiod in sync with CoAuthor because the UX now has a default selected when you open the CoAuthor (before it forced the user to select)
    this.setState({
      teamId: goalType == 1 ? teamId : undefined,
      timePeriod,
      teamOptions,
      timePeriodOptions,
    })
  }
  
  getSelectedTimePeriod = () => {
    const timePeriodOptions = this.props.addOkrData?.goalDetails?.filterOption ?? this.state.timePeriodOptions ?? [];

    // timePeriod defaults in order: saved timePeriod (edit OKR), first option in filterOptions (new OKR)
    return Object.values(timePeriodOptions).find(val => val.stats == 1) ?? timePeriodOptions[0];
  }

  handleCoauthorObjectiveClick = (e, value, portalNode, originator, placement = 'bottom-start') => {
    const { goalDetails } = this.props.addOkrData;
    const {teamId, timePeriod, teamOptions, timePeriodOptions} = this.state;
    window.openOkrCoauthor({
      type: "OPEN_OBJECTIVE_CHAT",
      initialDraft: value,
      anchor: e.target,
      placement,
      config: {
        team: teamId && {
          id: teamId,
          name: teamOptions.find(t => t.id == teamId)?.name
        },
        timePeriod,
        ...getCoauthorConfig(goalDetails, this.props.goalType),
        showPromptForTeamAndTimePeriod: true
      },
      originator,
      initialDraftOKR: {
        objective: value,
        keyResults: []
      },
      teamOptions,
      timePeriodOptions,
    }, portalNode);
  }

  render() {
    let _goalType = this.state.goalType;
    const { addOkrData } = this.props;
    if (
      typeof addOkrData.goalDetails !== "undefined" &&
      Object.keys(addOkrData.goalDetails).length
    ) {
      _goalType = this.props.addOkrData.goalDetails.type;
    }
    const { t } = this.props;
    // WW16812, Scroll issue
    const visibilityHidden = (this.props.addOkrData.goalDetails &&
      this.props.addOkrData.goalDetails.metrics &&
      this.props.addOkrData.goalDetails.metrics.length > 0) ? "" : "visibilityHidden";
      // console.log("visibilityHidden", visibilityHidden);

    const objectiveFieldElem = document.getElementById(TEXTAREA_IDS.newObjective);
    this.state.goalErrorText ?
      objectiveFieldElem && objectiveFieldElem.setAttribute('aria-invalid', 'true') :
      objectiveFieldElem && objectiveFieldElem.setAttribute('aria-invalid', 'false');


    return (
      <div className="subRootDiv">
        {this.state.setGoal && (
          <div className="TextAreaDivOnly">
            <div className="RectangleLeft">
              <div className="StrokeAndTextHolder">
                <div className="textarea-placeholder">
                  <textarea
                    ref={node => (this.textarea = node)}
                    onChange={this.handleChange}
                    onKeyDown={event => this.onEnterPress(event)}
                    className="goalNameClas" data-testid="goalNameClas"
                    id={TEXTAREA_IDS.newObjective}
                    aria-required="true"
                    aria-invalid="false"
                    value={this.state.addGoalValue}
                  >
                    {/* this.state.addGoalValue */}
                  </textarea>
                  <label className={this.state.addGoalValue ? "screen-reader-only" : "showPlaceholder"}
                    htmlFor={TEXTAREA_IDS.newObjective}
                  >
                    {t("Write the objective here and then press enter - inspire yourself and your team")}
                    <span>*</span>
                  </label>
                </div>
              </div>
              {this.state.goalErrorText && (
                <div className="ErrorGoalName addMarginTop" id='ErrorGoalNameId' role="alert" aria-live="polite">{t('Objective is required')} </div>
              )}
              {this.state.addGoalFinished && (
                <div className="Press-enter-when-fin addMarginTop">
                  {t('Press enter when finished')}
                </div>
              )}
            </div>
            <CoauthorButtonGroup>
              {wbConfig.default_org_locale == 'locale_1' && (
                <a href="https://www.workboard.com/okrs-by-function/" target="_blank">
                  {t('See sample OKRs')}
                </a>
              )}
              <CoauthorButtonWithPortal onClick={(e, portalNode) => this.handleCoauthorObjectiveClick(e, this.textarea.value, portalNode, { id: TEXTAREA_IDS.newObjective, type: 'objective' })} />
            </CoauthorButtonGroup>
          </div>
        )}

        {this.state.rightokrpane && (
          <EditGoal
            okrAlignmentSuggestionsDate ={this.state.okrAlignmentSuggestionsDate }
            addGoalValue={this.state.addGoalValue}
            rightokrpane={this.state.rightokrpane}
            setRightPaneState={this.setRightPaneState}
            saveGoalInfo={this.saveGoalInfo}
            goalDetails={this.props.addOkrData.goalDetails}
            divWsArchiEn={this.state.divWsArchiEn}
            goalType={this.state.goalType}
            defaultTimePeriod={this.getSelectedTimePeriod()?.value}
            {...this.props}
            ownerList={this.state.ownerList}
            addOkrObject={this.props.addOkrObject}
            // isFiscal={this.state.isFiscal}
          />
        )}

        {!this.state.setGoal && (
          <div className="saveGoalText">
            <div className="objTextHead" role="heading" aria-level="2">{t('OBJECTIVE')}</div>
            <div className="goalNameSec">
              <div tabIndex={-1} id={"goalTextObjectiveEmpty"} className="screen-reader-only" style={{outline:"0px !important"}} />
              {this.state.goalEditId == this.props.addOkrData.goalDetails.id ? (
                <div className="inlineGoalEdit clickOutInlineGoal">
                  <InlineKrEditComp
                    krkeys={this.props.addOkrData.goalDetails.id}
                    metricEdit={this.props.addOkrData.goalDetails.goal}
                    handleSaveKrChange={this.handleSaveGoalChange}
                    goalEditID={this.state.goalEditId}
                    goalErrText={this.state.goalErrorText}
                    labelText={t("Write the objective here - inspire yourself and your team")}
                  />
                  {this.state.goalErrorText && (
                    <div className="ErrorGoalName removeMargin">
                      {t('Objective is required')}
                    </div>
                  )}
                  <div className="goalInlineBtn">
                    {this.state.goalEditId ==
                      this.props.addOkrData.goalDetails.id && (
                        <span
                          role="button"
                          tabIndex={0}
                          aria-label={t("Cancel")}
                          className="krInlineCancel inLineBlk"
                          value={this.props.addOkrData.goalDetails.id}
                          onClick={() => this.UpdateGoalName()}
                          onKeyDown={e => KeyDownEvent(e, () =>
                            this.UpdateGoalName()
                          )}
                        ></span>
                      )}
                    {this.state.goalEditId ==
                      this.props.addOkrData.goalDetails.id && (
                        <span
                          role="button"
                          tabIndex={0}
                          aria-label={t("Submit")}
                          className="krInlineSave inLineBlk"
                          onClick={() =>
                            this.UpdateGoalName(
                              this.props.addOkrData.goalDetails.id
                            )
                          }
                          onKeyDown={e => KeyDownEvent(e, () => {
                            this.UpdateGoalName(
                              this.props.addOkrData.goalDetails.id
                            )
                          }
                          )}
                        ></span>
                      )}
                  </div>
                </div>
              ) : (
                  <div
                    role="textbox"
                    aria-label={t("Objective Use enter or spacebar to activate text area")}
                    className="goalText inlineGoalEdit wordWrapForText"
                    tabIndex={0}
                    id={TEXTAREA_IDS.editObjective}
                    value={this.props.addOkrData.goalDetails.id}
                    onClick={() =>
                      this.handleDoubleClickItem(
                        this.props.addOkrData.goalDetails.id
                      )
                    }
                    onKeyDown={e => KeyDownEvent(e, () =>
                      this.handleDoubleClickItem(
                        this.props.addOkrData.goalDetails.id
                      )
                    )}
                  >
                  <span  id="objNameLblId">{this.props.addOkrData.goalDetails.goal}</span>
                   </div>
                )}
              {this.state.goalEditId == this.props.addOkrData.goalDetails.id ? (
                ""
              ) : (
                <EditObjectiveToolbar>
                  <div
                    tabIndex={0}
                    role="button"
                    className="editGoalInfo"
                    aria-label={t("Edit")}
                    aria-describedby={"objNameLblId"}
                    data-testid="editGoalInfo"
                    onClick={this.editGoalRightPane}
                    onKeyDown={e => KeyDownEvent(e, () => {
                      this.editGoalRightPane();
                    })}
                   />
                  <CoauthorButtonWithPortal variant="icon" onClick={(e, portalNode) => this.handleCoauthorObjectiveClick(e, this.props.addOkrData.goalDetails.goal, portalNode, { id: TEXTAREA_IDS.editObjective, type: 'objective' }, "bottom-end" )} />
                </EditObjectiveToolbar>
                )}
              {/*

								<div className="goalText">
								  {this.props.addOkrData.goalDetails.goal}
								</div>
								<div className="editGoalInfo" onClick={this.editGoalRightPane} />
							*/}
            </div>
            {_goalType == 1 ? (
              <div className="goalInfo" role="heading" aria-level="4" data-testid="goalInfo">
                <span>{t('Team ')}| </span>
                <span>{this.props.addOkrData.goalDetails.team_name}</span>
                {this.state.alignCount > 0 && (
                  <span>
                    <span className="dotClass"></span>
                    {t('Aligned to')} {this.state.alignCount}
                    &nbsp;
                    {this.state.alignCount == 1 && t("objective")}
                    {this.state.alignCount > 1 && t("objectives")}
                  </span>
                )}
                <span className="dotClass"></span>
                <span>
                  {moment(this.props.addOkrData.goalDetails.start_date).format(
                    "MMM DD, YYYY"
                  ) + " - "}
                  {moment(this.props.addOkrData.goalDetails.target_date).format(
                    "MMM DD, YYYY"
                  )}
                </span>
              </div>
            ) : (
                <div className="goalInfo" role="heading" aria-level="4" data-testid="goalInfo">
                  {this.props.addOkrData.goalDetails.owner_fullname}
                  {this.state.alignCount > 0 && (
                    <span>
                      <span className="dotClass"></span>
                    {t('Aligned to')}
                      {this.state.alignCount}
                    &nbsp;
                      {this.state.alignCount == 1 && t("objective")}
                      {this.state.alignCount > 1 && t("objectives")}
                    </span>
                  )}
                  <span className="dotClass"></span>
                  {moment(this.props.addOkrData.goalDetails.start_date).format(
                    "MMM DD, YYYY"
                  ) + " - "}
                  {moment(this.props.addOkrData.goalDetails.target_date).format(
                    "MMM DD, YYYY"
                  )}
                </div>
              )}
          </div>
        )}

        {!this.state.setGoal && <div className="saveGoalEnd" />}

        {!this.state.setGoal && (
          <AddKrSection
            cancelKrInfo={this.cancelKrInfo}
            saveKrArr={this.saveKrArr}
            {...this.props}
            goalDetails={this.props.addOkrData.goalDetails}
            unmountGoalComp={this.props.unmountGoalComp}
            krTextWithOutsave={this.props.krTextWithOutsave}
            emprtyKrName={this.props.emprtyKrName}
            showRealOwner={this.props.addOkrData.show_real_owner}
            teamId={this.props.addOkrData.goalDetails.team_id }
            // isFiscal={this.state.isFiscal}
            t={t}
          />
        )}

            <ThemeProvider>
            <div className={"addDependencies " + visibilityHidden}>
              <div className="dependencieSec">
                <span>{t('When you are finished adding key results')}, </span>

                <span>{t('select Done.')}</span>
              </div>
            </div>
            </ThemeProvider>
      </div>
    );
  }
}

export default withTranslation()(AddGoal);
